import { render, staticRenderFns } from "./echart1.vue?vue&type=template&id=84d48944&"
import script from "./echart1.vue?vue&type=script&lang=js&"
export * from "./echart1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports